import React, { useRef } from 'react';
var VeltInlineCommentsSectionSortingDropdownContentItemName = function (props) {
    var defaultCondition = props.defaultCondition, sortOptionText = props.sortOptionText, children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-name", { ref: ref, "default-condition": [true, false].includes(defaultCondition) ? (defaultCondition ? 'true' : 'false') : undefined, "sort-option-text": sortOptionText }, children));
};
export default VeltInlineCommentsSectionSortingDropdownContentItemName;
